export interface UserOption {
  id: string;
  name: string;
}

/** A team membership row as consumed by the rule assignment pickers. */
export interface AssignableMembership {
  user?: string | { _id: string; name?: string | null } | null;
}

/** Assignable users for rule action pickers, deduped by user id. */
export function buildUserOptions(
  memberships: readonly AssignableMembership[] | undefined,
): UserOption[] {
  const byId = new Map<string, UserOption>();
  for (const membership of memberships ?? []) {
    const user = membership.user;
    if (!user || typeof user === "string") {
      continue;
    }
    if (!byId.has(user._id)) {
      byId.set(user._id, { id: user._id, name: user.name || user._id });
    }
  }
  return [...byId.values()];
}
